import KEY_CODES from 'common/KeyCodes';
import { CONSTANTS } from 'common/ListKeyboardNav';

const { LIST_ITEM_TABABLE_ITEM } = CONSTANTS;
const {
  ENTER_KEY,
  SPACE_KEY,
  TAB,
  ESCAPE
} = KEY_CODES;

const isSelectionKeyPressed = key => key && (key === ENTER_KEY || key === SPACE_KEY);

const handleWrapperFocus = (event, rowActionsRef) => {
  // check if event.target is HorizontalListButton (contains LIST_ITEM_TABABLE_ITEM in class name) and it is not MoreButton List (it's role is 'menu')
  if (!Array.from(event.target.classList).find(a => a.includes(LIST_ITEM_TABABLE_ITEM)) && event.target.getAttribute('role') !== 'menu') {
    rowActionsRef.current && rowActionsRef.current.querySelector('button').focus();
  }
};

const handleMenuKeyDown = (event, gridColumns, rowNode, colId, gridApi, triggerEl, getNextFocusableElAfterGrid, handleTabOnMenu) => {
  // If pagination is on, check if the cell is the last one on current page
  const isLastOnCurrentPaginationPage =
    gridApi.paginationGetTotalPages() > 1 &&
    gridApi.paginationGetPageSize() - 1 === rowNode.rowIndex &&
    gridColumns[gridColumns.length - 1].colId === colId;

  // check if the cell is the last cell in the Grid or last visible cell on current page.
  const isLast = rowNode.lastChild || isLastOnCurrentPaginationPage;

  if (event.key === TAB) {
    if (event.shiftKey) {
      // Shift key + TAB, focus the column before the row action column.
      gridApi.ensureColumnVisible(gridColumns[gridColumns.length - 2]);
      gridApi.setFocusedCell(rowNode.rowIndex, gridColumns[gridColumns.length - 2]);
    } else if (isLast) {
      if (getNextFocusableElAfterGrid) {
        // if the row action cell is the last cell in the Grid or last visible cell on current page, focus on the element next to the Grid (Like StatusBar)
        // eslint-disable-next-line no-param-reassign
        gridApi.context.lastCell = false;
        setTimeout(() => getNextFocusableElAfterGrid().focus());
      } else {
        // if getNextFocusableElAfterGrid is not provided, focus back to trigger element (Like MoreButton)
        // eslint-disable-next-line no-param-reassign
        gridApi.context.lastCell = true;
        triggerEl && setTimeout(() => triggerEl.current.focus());
      }
    } else if (handleTabOnMenu) {
      handleTabOnMenu(gridApi, rowNode);
    } else {
      // focus on next cell
      gridApi.ensureColumnVisible(gridColumns[0]);
      gridApi.setFocusedCell(rowNode.rowIndex + 1, gridColumns[0]);
    }
  } else if (event.key === ESCAPE) {
    // ESCAPE key, focus the column before the row action column. (same action as Shift key + TAB)
    gridApi.ensureColumnVisible(gridColumns[gridColumns.length - 2]);
    gridApi.setFocusedCell(rowNode.rowIndex, gridColumns[gridColumns.length - 2]);
  }
};

export {
  handleWrapperFocus,
  isSelectionKeyPressed,
  handleMenuKeyDown
};